<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 pa-4">
        <v-row>
          <!-- <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col> -->
          <v-col>
              <h2>รายงาน ของรางวัล</h2>
            </v-col>
            <v-col class="text-right">
                <v-btn
                  class="btn-color"
                  color="indigo"
                  outlined
                >
                <download-excel
                  class="btn btn-default indigo--text"
                  :data="export_dataAll"
                  :fields="exportAll_field"
                  :type="exportType"
                  :worksheet="exportWorksheet"
                  :name="exportFileNameCode"
                >
                <v-icon color="indigo">
                  mdi-download
                </v-icon>
                  Export Data
                </download-excel>
                </v-btn>
            </v-col>
        </v-row>

        <v-row class="pb-3 mt-5 ma-0 w-100 col-grid">
         <div class="pa-0">
           <v-menu
               ref="menu"
               v-model="menu"
               :close-on-content-click="false"
               :return-value.sync="date"
               transition="scale-transition"
               offset-y
               min-width="auto"
             >
               <template v-slot:activator="{ on, attrs }">
                 <v-text-field
                   v-model="dateRangeText"
                   label="ค้นหาตามวันที่"
                   prepend-inner-icon="mdi-calendar"
                   readonly
                   outlined
                   dense
                   v-bind="attrs"
                   v-on="on"
                   clearable
                   hide-details
                 ></v-text-field>
               </template>
               <v-date-picker v-model="date" no-title scrollable range>
                 <v-spacer></v-spacer>
                 <v-btn text color="primary" @click="menu = false">
                   Cancel
                 </v-btn>
                 <v-btn text color="primary" @click="$refs.menu.save(date)">
                   OK
                 </v-btn>
               </v-date-picker>
             </v-menu>
         </div>
         <div class="pa-0">
           <v-text-field
             v-model="memberSearch"
             label="ค้นหา ชื่อ / เบอร์โทร"
             prepend-inner-icon="mdi-magnify"
             outlined
             dense
             clearable
             hide-details
           ></v-text-field>
         </div>
         <v-btn class="btn-grid" color="indigo" dark @click.stop="getDataItemAllRedeemStatus(), getDataItem1(),getDataItem2()">ค้นหา</v-btn>
       </v-row>
        <!-- data table -->
        <v-row class="mt-0">
          <v-col cols="12">
            <v-card>
              <v-tabs v-model="tab" background-color="#1B437C" dark>
                <v-tab> รอรับของรางวัล </v-tab>
                <v-tab> รับของรางวัล </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="columns1"
                        :items="dataItem1"
                        :search="memberSearch"
                        :custom-filter="memberFilter"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.point`]="{ item }">
                          {{ (item.point || item.point === 0) ? formatNumber(item.point) : (item.remark ? parseInt(item.remark.split(' ')[1])*parseInt(item.disCountExchangeRate) : '-') }}
                        </template>
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.LAST_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.LAST_DATE) }}
                        </template>
                        <template v-slot:[`item.endDate`]="{ item }">
                          <!-- <v-chip
                            :color="color"
                            dark
                        > -->
                          {{ thaiFormattedDate(item.endDate) }}
                          <!-- </v-chip> -->
                        </template>
                        <template v-slot:[`item.linePicture`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.linePicture" alt="img"
                          /></v-avatar>
                        </template>
                        <template v-slot:[`item.CHKDATE`]="{ item }">
                          <v-chip :color="getColor(item.CHKDATE)" dark>
                            {{ item.CHKDATE }}
                          </v-chip>
                        </template>
                      </v-data-table></v-card-text
                    >
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <!-- <v-row>
                    <v-col class=" text-right">
                      <v-btn class="export-btn" dark color="green">
                        <v-icon left>mdi-download</v-icon>
                        <download-excel
                          class="btn btn-default text-white"
                          :data="export_data"
                          :fields="export_field"
                          :type="exportType"
                          :worksheet="exportWorksheet"
                          :name="exportFileName"
                        >
                          Export Data
                        </download-excel>
                      </v-btn>
                    </v-col>
                  </v-row> -->

                  <v-card flat>
                    <!-- <v-btn class="export-btn btn-color" dark @click="exportExcel()" style="
                        background-color: rgb(27, 67, 157) !important;
                              color: white !important;
                            ">
                      <v-icon left style="color: white !important;">mdi-download</v-icon>
                      Export Member
                    </v-btn> -->
                    <v-card-text>
                      <v-data-table
                        :headers="columns2"
                        :items="dataItem2"
                        :search="memberSearch"
                        :custom-filter="memberFilter"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.point`]="{ item }">
                          {{ item.levelSettingsReward !== '[]' && item.levelSettingsReward !== null ? '-' : (item.point || item.point === 0) ? formatNumber(item.point) : (item.remark ? formatNumber(parseInt(item.remark.split(' ')[1])*parseInt(item.disCountExchangeRate)) : '-') }}
                        </template>
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.CREATE_DATE) }}
                        </template>
                        <template v-slot:[`item.useDate`]="{ item }">
                          {{ item.useDate }}
                        </template>
                        <template v-slot:[`item.endDate`]="{ item }">
                          <!-- <v-chip
                            :color="color"
                            dark
                        > -->
                          {{ thaiFormattedDate(item.endDate) }}
                          <!-- </v-chip> -->
                        </template>
                        <template v-slot:[`item.linePicture`]="{ item }">
                          <v-avatar color="primary" size="40">
                            <img :src="item.linePicture" alt="img"
                          /></v-avatar>
                        </template> </v-data-table
                    ></v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
        <!-- end data table -->
      </div>
    </v-main>
  </div>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import memberSearch from '@/mixins/memberSearch'

export default {
  mixins: [memberSearch],
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    moment,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  created () {},
  data () {
    return {
      PK: '',
      path: '/rewardCode/', // Path Model
      // path2: '/ReportQRCode/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงาน',
          disabled: false,
          href: '/Tool/ReportCode'
        }
      ],

      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      searchAll2: '',
      menu: false,
      startDate: '',
      endDate: '',
      // Data Table Config
      tab: null,
      columns1: [
        { text: 'รูปโปรไฟล์', value: 'linePicture' },
        { text: 'ชื่อ', value: 'lineName' },
        { text: 'รหัสของรางวัล', value: 'rewardCodeId' },
        { text: 'สินค้าที่แลก', value: 'name' },
        { text: 'คะแนนที่แลก', value: 'point' },
        { text: 'หมายเหตุ', value: 'remark' },
        { text: 'วันหมดอายุ', value: 'endDate' },
        { text: 'การรับสินค้า', value: 'supply' },
        { text: 'สถานะหมดอายุ', value: 'CHKDATE' }
      ],
      dataItem1: [],
      columns2: [
        { text: 'รูปโปรไฟล์', value: 'linePicture' },
        { text: 'ชื่อ', value: 'lineName' },
        { text: 'รหัสของรางวัล', value: 'rewardCodeId' },
        { text: 'สินค้าที่แลก', value: 'name' },
        { text: 'คะแนนที่แลก', value: 'point' },
        { text: 'หมายเหตุ', value: 'remark' },
        { text: 'ผู้รับผิดชอบ', value: 'displayName' },
        { text: 'การรับสินค้า', value: 'supply' },
        { text: 'วันที่รับสิ้นค้า', value: 'useDate' }
        // { text: 'วันที่ทำเรื่อง', value: 'LAST_DATE' },
        // { text: 'วันหมดอายุ', value: 'endDate' },
        // { text: 'หมดอายุ', value: 'CHKDATE' }
      ],
      dataItem2: [],
      dataItem3: [],
      exportType: 'xls',
      exportFileNameCode: '',
      exportFileName: 'รับของรางวัล.xls',
      exportFile: 'รายชื่อผู้ใช้ที่จะถูกตัดคะแนนประจำเดือน.xls',
      exportWorksheet: 'WorkSheet',
      export_field: {
        ชื่อ: 'lineName',
        รหัสของรางวัล: 'rewardCodeId',
        สินค้าที่แลก: 'name',
        จำนวนเหรียญที่แลก: 'point',
        การรับสินค้า: 'supply',
        วันที่รับสิ้นค้า: 'useDate'
      },
      exportAll_field: {
        'ลำดับ': 'ลำดับ',
        ชื่อ: 'nameCustomer',
        บัญชีไลน์: 'lineName',
        lineUserId: 'lineUserId',
        เบอร์โทรศัพท์: {
          field: 'tel',
          callback: (value) => {
            let telString = value.toString()
            return telString.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          },
          formatNumber: '@'
        },
        รหัสของรางวัล: 'rewardCodeId',
        สินค้าที่แลก: 'name',
        วันที่แลกคะแนน: {
          field: 'CREATE_DATE',
          callback: (value) => {
            const formattedValue = value ? moment(String(value)).format('DD/MM/YYYY') : null

            if (formattedValue) {
              return moment(formattedValue, 'DD/MM/YYYY').add(543, 'years').format('DD/MM/YYYY')
            } else {
              return ''
            }
          }
        },
        คะแนนที่แลก: 'point',
        คะแนนคงเหลือ: 'currentPoint',
        การรับสินค้า: 'supply',
        วันที่รับสิ้นค้า: {
          field: 'useDate',
          callback: (value) => {
            const formattedValue = value ? moment(String(value)).format('DD/MM/YYYY') : null

            if (formattedValue) {
              return moment(formattedValue, 'DD/MM/YYYY').add(543, 'years').format('DD/MM/YYYY')
            } else {
              return ''
            }
          }
        },
        วันหมดอายุ: {
          field: 'endDate',
          callback: (value) => {
            const formattedValue = value ? moment(String(value)).format('DD/MM/YYYY') : null
            if (formattedValue) {
              return moment(formattedValue, 'DD/MM/YYYY').add(543, 'years').format('DD/MM/YYYY')
            } else {
              return ''
            }
          }
        },
        สถานะหมดอายุ: 'CHKDATE',
        ผู้รับผิดชอบ: 'displayName',
        หมายเหตุ: 'remark'
      },
      date: [],
      export_data: null,
      export_dataAll: null
      // End Data Table Config
    }
  },
  async mounted () {
    this.dataReady = false
    this.generateFileName()
    // Get Data
    await this.getDataItem1()
    await this.getDataItem2()
    await this.getDataItemAllRedeemStatus()

    this.getColor()
  },
  computed: {
    dateRangeText: {
      get () {
        return this.date.join(' - ')
      },
      set (value) {
        this.date = value ? value.split(' - ') : []
      }
    }
  },
  methods: {
    generateFileName () {
      const date = moment().format('DDMMYYYY')
      this.exportFileNameCode = `Report_Reward_${date}.xls`
    },
    beforeExport () {
      this.export_dataAll = this.export_dataAll.map((item, index) => ({
        ...item,
        ลำดับ: index + 1
      }))
    },
    async getDataItem1 () {
      // try {
      this.dataItem1 = []
      let sql = ''
      await this.setDate()

      if (this.session.data.userTypeGroup === 'cashier') {
        sql =
          this.DNS_IP +
          '/rewardCode/get?redeemStatus=get&shopId=' +
          this.session.data.shopId +
          '&userId=' +
          this.session.data.userId
      } else {
        sql =
          this.DNS_IP +
          '/rewardCode/get?redeemStatus=get&shopId=' +
          this.session.data.shopId
      }
      if (this.startDate && this.endDate) {
        sql += `&LAST_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
      }
      await axios
        .get(sql)
        .then(async (response) => {
          console.log('getData1', response.data)
          this.dataReady = true
          if (response.data.status === false) {
            this.dataItem1 = []
          } else {
            this.dataItem1 = response.data
            this.dataItem1.map((el) => {
              this.getColor(this.thaiFormattedDate(el.endDate))
            })
          }

          // if (this.dataItem1.length === 0 || this.dataItem1.status === false) {
          //   this.dataItem1 = []
          // }
        })
      // eslint-disable-next-line handle-callback-err
      // .catch(error => {
      //   console.log(error)
      //   this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
      //   this.dataReady = true
      // })
    },
    getColor (CHKDATE) {
      if (CHKDATE === 'หมดอายุ') return 'red'
      else return 'green'
    },
    async getDataItem2 () {
      // Clear Data ทุกครั้ง
      this.dataItem2 = []
      await this.setDate()
      console.log('getDataItem2')
      let sql = ''
      if (this.session.data.userTypeGroup === 'cashier') {
        sql =
          this.DNS_IP +
          '/rewardCode/DESC/get?redeemStatus=use&shopId=' +
          this.session.data.shopId +
          '&userId=' +
          this.session.data.userId
      } else {
        sql =
          this.DNS_IP +
          '/rewardCode/DESC/get?redeemStatus=use&shopId=' +
          this.session.data.shopId
      }
      if (this.startDate && this.endDate) {
        sql += `&LAST_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
      }
      axios
        .get(sql)
        .then(async (response) => {
          console.log('getData2', response.data)
          this.dataReady = true
          this.dataItem2 = response.data
          this.export_data = response.data
          if (this.dataItem2.length === 0 || this.dataItem2.status === false) {
            this.dataItem2 = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
      console.log()
    },
    async getDataItemAllRedeemStatus () {
      // Clear Data ทุกครั้ง
      this.dataItem3 = []
      await this.setDate()
      console.log('getDataItem2')
      let sql = ''
      if (this.session.data.userTypeGroup === 'cashier') {
        sql =
      this.DNS_IP +
      '/rewardCodeAll/DESC/get?redeemStatus=get&redeemStatus=use&shopId=' +
      this.session.data.shopId +
      '&userId=' +
      this.session.data.userId
      } else {
        sql =
      this.DNS_IP +
      '/rewardCodeAll/DESC/get?redeemStatus=get&redeemStatus=use&shopId=' +
      this.session.data.shopId
      }
      if (this.startDate && this.endDate) {
        sql += `&LAST_DATE=${encodeURIComponent(`${this.startDate},${this.endDate}`)}`
      }
      axios
        .get(sql)
        .then(async (response) => {
          console.log('getData2', response.data)
          this.dataReady = true
          this.dataItem3 = response.data
          if (this.dataItem3.length === 0 || this.dataItem3.status === false) {
            this.dataItem3 = []
          }
          this.export_dataAll = this.dataItem3
          await this.beforeExport()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    setDate () {
      this.startDate = ''
      this.endDate = ''
      if (this.date.length === 2) {
        this.date.sort()
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[1]).format('YYYY-MM-DD')
      } else if (this.date.length === 1) {
        this.startDate = moment(this.date[0]).format('YYYY-MM-DD')
        this.endDate = moment(this.date[0]).format('YYYY-MM-DD')
      }
    },
    exportExcel () {
      var data = []
      var dataFinal = {}
      let pushDataFinal = []

      this.dataItem2.map((el) => {
        data.push(el)
      })
      console.log('DATA', data)
      if (
        this.$session.getAll().data.shopId ===
          'U97dd281445cde30a599a5f5515a4e937' ||
        this.$session.getAll().data.shopId ===
          'U60f3a4215c86a978d5f6191292ad0109'
      ) {
        data.map((resule) => {
          // console.log('resule.IdbarCodeMember', resule.IdbarCodeMember)
          dataFinal = {
            เลขโควต้า: resule.barcodeNum,
            ชื่อไลน์: resule.lineName,
            ชื่อ: resule.nameCustomer,
            เพศ: resule.gender === 'male' ? 'ชาย' : 'หญิง',
            เบอร์โทรศัพท์: resule.tel
          }
          pushDataFinal.push(dataFinal)
        })
      } else {
        data.map((resule) => {
          // console.log('resule.IdbarCodeMember', resule.IdbarCodeMember)
          dataFinal = {
            linUserId: resule.liffUserId,
            ชื่อไลน์: resule.name,
            ชื่อ: resule.nameCustomer,
            เพศ: resule.gender,
            เบอร์โทรศัพท์: resule.tel,
            คะแนนที่ได้รับ: resule.collectPoint,
            คะแนนที่ถูกใช้: resule.redeemPoint,
            คะแนนคงเหลือ: resule.currentPoint,
            คะแนนที่จะถูกตัดเดือนนี้: resule.balancePoint,
            วันเกิด: resule.birthDay,
            ระดับ: resule.LevelName,
            วันที่สมัครสมาชิก: resule.CREATE_DATE
          }
          pushDataFinal.push(dataFinal)
        })
      }

      const dataWS = XLSX.utils.json_to_sheet(pushDataFinal)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'ข้อมูลรายชื่อลูกค้า.xlsx')
    }
  },
  formatDateToDDMMYYYY (date) {
    if (!date) return ''
    const d = new Date(date)
    const day = ('0' + d.getDate()).slice(-2)
    const month = ('0' + (d.getMonth() + 1)).slice(-2)
    const year = d.getFullYear()
    return `${day}/${month}/${year}`
  },

  prepareExportData () {
    this.export_dataAll = this.export_dataAll.map(item => {
      return {
        ...item,
        CREATE_DATE: this.formatDateToDDMMYYYY(item.CREATE_DATE),
        useDate: this.formatDateToDDMMYYYY(item.useDate),
        endDate: this.formatDateToDDMMYYYY(item.endDate)
      }
    })
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/ReportCode.vue